export const manageAlertFields = (baseArray, key, condition) => {
  const isPresentInBaseArray = baseArray.includes(key);

  if (
    (isPresentInBaseArray && condition) ||
    (!isPresentInBaseArray && !condition)
  ) {
    return baseArray;
  }

  if (isPresentInBaseArray && !condition) {
    return baseArray.filter((item) => item !== key);
  }

  if (!isPresentInBaseArray && condition) {
    return [...baseArray, key];
  }

  return [];
};

export const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
